<!-- Header -->
<div class="header center header-color-dark transparent-dark">
  <div class="container">
    <div class="header-logo">
      <h3 class="font-family-syne letter-spacing-1">
        <a routerLink="/">Komo</a>
      </h3>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Startup Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Design Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Corporate Business</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">Consulting</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-five">Digital Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-six">SEO Agency</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/team-details">Team Details</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-two">Service Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-three">Service Three</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/service-four">Service Four</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two-column">Portfolio Two Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three-column">Portfolio Three Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-four-column">Portfolio Four Columns</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-detail">Portfolio Details</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li><a href="/"><i class="bi bi-facebook"></i></a></li>
        <li><a href="/"><i class="bi bi-twitter-x"></i></a></li>
        <li><a href="/"><i class="bi bi-linkedin"></i></a></li>
      </ul>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->

<!-- Title -->
<div class="section-lg bg-image" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg')">
    <div class="bg-white-07">
        <div class="container">
            <div class="row g-4">
                <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
                    <h1 class="fw-light font-family-syne m-0">More Than IT Services, We're Your Strategic Technology
                        Partner.</h1>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</div>
<!-- end Title -->

<!-- Blog Posts -->
<div class="section">
  <div class="container">
    <div class="row column-3 spacing-3">
      <div class="col-12 col-md-4 col-sm-4 col-lg-4 col-xl-4 mrb-30" *ngFor="let post of blogPosts">
        <div class="hoverbox-6 mb-3 border-radius">
          <a [routerLink]="post.link">
            <img [src]="post.img" [alt]="post.title">
            <div class="content top bg-dark border-radius">
              <span class="font-family-poppins font-small fw-normal uppercase text-white">{{ post.date }}</span>
            </div>
          </a>
        </div>
        <h5 class="fw-medium">
          <a class="text-link-1 text-color-theme" [routerLink]="post.link">{{ post.title }}</a>
        </h5>
        <p>{{ post.excerpt }}</p>
      </div>
    </div>

    <!-- Pagination -->
    <nav>
      <ul class="pagination justify-content-center mt-5">
        <li class="page-item"><a class="page-link" href="#">&laquo;</a></li>
        <li class="page-item active"><a class="page-link" href="#">1</a></li>
        <li class="page-item"><a class="page-link" href="#">2</a></li>
        <li class="page-item"><a class="page-link" href="#">3</a></li>
        <li class="page-item"><a class="page-link" href="#">&raquo;</a></li>
      </ul>
    </nav>
  </div>
</div>
<!-- end Blog Posts -->
